module.exports = __webpack_public_path__ + "static/media/banner4.640c72b0.jpg";